import DataSharing_Shares_AccessSharePage from "@DataSharing/Shares/Pages/AccessSharePage.vue";
import DataSharing_Shares_AdminActiveSharesPage from "@DataSharing/Shares/Pages/AdminActiveSharesPage.vue";
import DataSharing_Shares_MySharesPage from "@DataSharing/Shares/Pages/MySharesPage.vue";
import DataSharing_Shares_ResourcePage from "@DataSharing/Shares/Pages/ResourcePage.vue";
import DataSharing_Shares_ShareNotificationPage from "@DataSharing/Shares/Pages/ShareNotificationPage.vue";
import DataSharing_Shares_SharePage from "@DataSharing/Shares/Pages/SharePage.vue";

export const routes = [
    {
        path: "/sharing/access/:id",
        component: DataSharing_Shares_AccessSharePage
    },
    {
        path: "/sharing/admin/activeshares/:tid",
        component: DataSharing_Shares_AdminActiveSharesPage
    },
    {
        path: "/sharing/share/:provider/:resourceId/:shareId",
        component: DataSharing_Shares_SharePage
    },
    {
        path: "/sharing/myshares",
        component: DataSharing_Shares_MySharesPage
    },
    {
        path: "/sharing/resource/:provider/:resourceId",
        component: DataSharing_Shares_ResourcePage
    },
    {
        path: "/sharing/share/notification/:shareId",
        component: DataSharing_Shares_ShareNotificationPage
    },
]